import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-drip-guide',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './drip-guide.component.html',
  styleUrls: ['./drip-guide.component.scss']
})
export class DripGuideComponent {

  examples = [
    {
      scenario: 'Quick Submission',
      description: 'Submit all URLs immediately',
      dripEnabled: false,
      interval: 0,
      urls: 5,
      timeline: 'All 5 URLs submitted instantly'
    },
    {
      scenario: 'Gentle Drip',
      description: 'Spread submissions over time',
      dripEnabled: true,
      interval: 5,
      urls: 5,
      timeline: '1st URL: Now → 2nd URL: 5 min → 3rd URL: 10 min → 4th URL: 15 min → 5th URL: 20 min'
    },
    {
      scenario: 'Slow & Steady',
      description: 'Maximum spacing for natural indexing',
      dripEnabled: true,
      interval: 30,
      urls: 3,
      timeline: '1st URL: Now → 2nd URL: 30 min → 3rd URL: 60 min'
    }
  ];

  benefits = [
    {
      icon: 'ph ph-shield-check',
      title: 'Avoid Rate Limits',
      description: 'Prevents overwhelming the indexing service with too many requests at once'
    },
    {
      icon: 'ph ph-plant',
      title: 'Natural Growth Pattern',
      description: 'Mimics organic content discovery and indexing behavior'
    },
    {
      icon: 'ph ph-lightning',
      title: 'Better Success Rate',
      description: 'Reduces chances of requests being flagged or rejected'
    },
    {
      icon: 'ph ph-chart-bar',
      title: 'Controlled Processing',
      description: 'Manage your indexing queue and monitor progress in real-time'
    }
  ];

  faqs = [
    {
      question: 'What happens to my first URL?',
      answer: 'The first URL is always submitted immediately, regardless of drip settings. Only subsequent URLs follow the drip schedule.'
    },
    {
      question: 'Can I change the interval for different submissions?',
      answer: 'Yes! You can set a different interval each time you submit URLs. The setting only applies to that specific batch.'
    },
    {
      question: 'What if I want to submit more URLs while drip is running?',
      answer: 'You can submit new batches anytime. Each batch follows its own drip schedule independently.'
    },
    {
      question: 'How do I track drip progress?',
      answer: 'Visit the History page to see real-time countdown timers for each scheduled URL and their current status.'
    },
    {
      question: 'What\'s the minimum interval I can set?',
      answer: 'The minimum interval is 1 minute to ensure proper spacing between submissions.'
    }
  ];

  openFaq = -1;

  toggleFaq(index: number) {
    this.openFaq = this.openFaq === index ? -1 : index;
  }
}